import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Account } from '../models/account';
import { Api } from '../../api';
import { AppState } from '../../store/models/app-state';
import { TermsAndConditions } from '../models/terms-and-conditions';

export const RECEIVE_ACCOUNT = 'RECEIVE_ACCOUNT';
export const RECEIVE_ACCOUNTS = 'RECEIVE_ACCOUNTS';
export const RECEIVE_TERMS_AND_CONDITIONS = 'RECEIVE_TERMS_AND_CONDITIONS';
export const REQUEST_ACCOUNTS = 'REQUEST_ACCOUNTS';
export const REQUEST_ACCOUNTS_COMPLETE = 'REQUEST_ACCOUNTS_COMPLETE';
export const RESET_BONUS_CONDITIONS = 'RESET_BONUS_CONDITIONS';

const requestAccounts = () => {
    return {
        type: REQUEST_ACCOUNTS,
    };
};

const requestAccountsComplete = () => {
    return {
        type: REQUEST_ACCOUNTS_COMPLETE,
    };
};

const receiveAccounts = (accounts: Account[]) => {
    return {
        type: RECEIVE_ACCOUNTS,
        accounts,
    };
};

export const updateAccounts = (searchParams: URLSearchParams) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch(requestAccounts());

        const response = await api.accounts.cget(searchParams);

        dispatch(requestAccountsComplete());
        if (response.success) {
            dispatch(receiveAccounts(response.result.items));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

const receiveBonusConditions = (termsAndConditions: TermsAndConditions) => {
    return {
        type: RECEIVE_TERMS_AND_CONDITIONS,
        termsAndConditions,
    };
};

export const resetBonusConditions = () => {
    return {
        type: RESET_BONUS_CONDITIONS,
    };
};

export const fetchBonusConditions = (accountId: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const response = await api.accounts.getBonusConditions(accountId);
        if (response.success) {
            dispatch(receiveBonusConditions(response.result));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
